import {API_DRIVER} from "../config/axios";

const getNotificationRequestUrl = (endpointUrl: string) => {
    return `/api/notifications${endpointUrl}`
}

const NotificationService = {
    fetchNotificationsForUser: () => {
        return API_DRIVER.get(getNotificationRequestUrl(""))
    },
    readNotification: (notificationId: string) => {
        return API_DRIVER.patch(getNotificationRequestUrl(`/${notificationId}`))
    },
    markAllAsRead: () => {
        return API_DRIVER.patch(getNotificationRequestUrl(`/read/all`))
    },
}

export default NotificationService